import { Base64 } from 'js-base64';

function handleSeoLinkClick(event) {
  const base64Href = this.getAttribute('data-encodehref');
  const target = this.getAttribute('target');
  if(base64Href && (event.type === 'click' || event.key === 'Enter')){
    const href = Base64.decode(base64Href);
    if(event.ctrlKey || event.metaKey || target === '_blank'){
      const newWindow = window.open(href, '_blank');
      // Reset opener for security purpose (https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/)
      newWindow.opener = null;
      newWindow.focus();
    } else {
      document.location.href = href;
    }
  }
}

export function init() {
  $('body').delegate('.js-seo-hidden-link', 'click', handleSeoLinkClick);
  $('body').delegate('.js-seo-hidden-link', 'keydown', handleSeoLinkClick);
}



// WEBPACK FOOTER //
// ./src/catalog/product-list/seoLinks.js